export const initialValues = {
  applicantInformation: {
    fullName: '',
    contactEmail: '',
  },
  step1: {
    name: '',
    submitter: '',
    submitterTitle: '',
    streetAddress: '',
    phone: '',
    fax: '',
    email: '',
  },
  step2: {
    f1: {
      selectedFiles: [],
    },
    f2: {
      selectedFiles: [],
    },
    f3: {
      selectedFiles: [],
    },
    f4: {
      selectedFiles: [],
    },
    f5: {
      selectedFiles: [],
    },
  },
  step3: {
    section1: {
      doesDocumentDefines: '',
      articlesOfIncorporation: {
        section: '',
        page: '',
        paragraph: '',
      },
      byLaws: {
        page: '',
        paragraph: '',
      },
      charter: {
        page: '',
        paragraph: '',
      },
    },
    f1: { selectedFiles: [] },
    f2: { selectedFiles: [] },
  },
  step4: {
    section1: {
      q1: '',
      articlesOfIncorporation: {
        section: '',
        page: '',
        paragraph: '',
      },
      byLaws: {
        page: '',
        paragraph: '',
      },
      charter: {
        page: '',
        paragraph: '',
      },
    },
    providedEvidence: '',
    f1: { selectedFiles: [] },
    f2: { selectedFiles: [] },
    f3: { selectedFiles: [], section: '', page: '', paragraph: '' },
    section2: {
      isChartered: '',
      q2: '',
      articlesOfIncorporation: {
        section: '',
        page: '',
        paragraph: '',
      },
      byLaws: {
        page: '',
        paragraph: '',
      },
      charter: {
        page: '',
        paragraph: '',
      },
    },
    section3: {
      isSponsored: '',
      q3: '',
      articlesOfIncorporation: {
        section: '',
        page: '',
        paragraph: '',
      },
      byLaws: {
        page: '',
        paragraph: '',
      },
      charter: {
        page: '',
        paragraph: '',
      },
    },
    boardMembers: []
  },
  step5: {
    f1: { selectedFiles: [] },
    f2: { selectedFiles: [] },
    f3: { selectedFiles: [] },
    fiscalYear: '',
    hasCompliance: '',
    f4: { selectedFiles: [] },
    f5: { selectedFiles: [] },
    f6: { selectedFiles: [], description: '' },
    staffs : []
  },
};
